const now = new Date().toISOString();

export const MOCK_ADMINS = [
  {
    id: "adm-001",
    email: "mtellez@tvmarkets.com",
    password: "Tradeview123$",
    username: "Alejandro Tellez",
    enable: true,
    isSuperAdmin: true,
    createdAt: now,
    updatedAt: now,
    source: "mock",
  },
  {
    id: "adm-002",
    email: "soporte@tvmarkets.com",
    password: "Support2026!",
    username: "TV Support",
    enable: true,
    isSuperAdmin: false,
    createdAt: now,
    updatedAt: now,
    source: "mock",
  },
  {
    id: "adm-003",
    email: "risk.manager@tvmarkets.com",
    password: "RiskSecure88#",
    username: "Risk Manager",
    enable: true,
    isSuperAdmin: false,
    createdAt: now,
    updatedAt: now,
    source: "mock",
  },
  {
    id: "adm-004",
    email: "ops.admin@tvmarkets.com",
    password: "OpsAdmin456*",
    username: "Operations Admin",
    enable: false,
    isSuperAdmin: false,
    createdAt: now,
    updatedAt: now,
    source: "mock",
  },
  {
    id: "adm-005",
    email: "compliance@tvmarkets.com",
    password: "Compliance!2026",
    username: "Compliance Team",
    enable: true,
    isSuperAdmin: false,
    createdAt: now,
    updatedAt: now,
    source: "mock",
  },
  {
    id: "adm-006",
    email: "ceo.office@tvmarkets.com",
    password: "OfficeRoot999!",
    username: "Executive Office",
    enable: true,
    isSuperAdmin: true,
    createdAt: now,
    updatedAt: now,
    source: "mock",
  },
];

const normalizeSearch = (value) => String(value || "").trim().toLowerCase();

export const filterMockAdmins = (admins, filters) => {
  const search = normalizeSearch(filters?.search);
  const enable = filters?.enable;
  const isSuperAdmin = filters?.isSuperAdmin;

  return admins.filter((admin) => {
    const matchesSearch =
      !search ||
      normalizeSearch(admin.email).includes(search) ||
      normalizeSearch(admin.username).includes(search);

    const matchesEnable =
      enable === "" ? true : admin.enable === (enable === "true");

    const matchesRole =
      isSuperAdmin === ""
        ? true
        : admin.isSuperAdmin === (isSuperAdmin === "true");

    return matchesSearch && matchesEnable && matchesRole;
  });
};

export const createMockAdmin = (admins, payload) => {
  const timestamp = new Date().toISOString();

  const newAdmin = {
    id: `adm-${Date.now()}`,
    email: payload.email,
    password: payload.password,
    username: payload.username,
    enable: !!payload.enable,
    isSuperAdmin: !!payload.isSuperAdmin,
    createdAt: timestamp,
    updatedAt: timestamp,
    source: "mock",
  };

  return [newAdmin, ...admins];
};

export const updateMockAdmin = (admins, adminId, payload) => {
  return admins.map((admin) => {
    if ((admin.id || admin._id) !== adminId) return admin;

    return {
      ...admin,
      email: payload.email,
      username: payload.username,
      enable: !!payload.enable,
      isSuperAdmin: !!payload.isSuperAdmin,
      password:
        payload.password && String(payload.password).trim() !== ""
          ? payload.password
          : admin.password,
      updatedAt: new Date().toISOString(),
    };
  });
};

export const deleteMockAdmin = (admins, adminId) => {
  return admins.filter((admin) => (admin.id || admin._id) !== adminId);
};